import { useTranslation } from "react-i18next";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ALL_VALUE = "__ALL__";

/** Single-select dropdown for a lookup code list, rendering translated labels. */
export default function LookupSelect({ options, value, onChange, labelPrefix, placeholder, testId, includeAll = false }) {
  const { t } = useTranslation();
  return (
    <Select value={value || (includeAll ? ALL_VALUE : "")} onValueChange={(v) => onChange(v === ALL_VALUE ? undefined : v)}>
      <SelectTrigger className="h-12 rounded-xl bg-[#FAFAFA] border-black/10" data-testid={testId}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="rounded-xl max-h-72">
        {includeAll && (
          <SelectItem value={ALL_VALUE} data-testid={`${testId}-option-all`}>
            {t("common.all")}
          </SelectItem>
        )}
        {options.map((code) => (
          <SelectItem key={code} value={code} data-testid={`${testId}-option-${code}`}>
            {t(`${labelPrefix}.${code}`)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
